import { canAddObjectToParent, isTemplatePage, templateSelectionParent } from './templateObjectRules.js';

function disableComponent(node, obj, activePage) {
    if (isTemplatePage(activePage)) {
        const parent = templateSelectionParent(node, activePage);
        return !canAddObjectToParent(parent, obj).valid;
    }
    if (node !== undefined) {
        if (node.obj === 'tabview') {
            return obj !== 'tab';
        }
        if (node.isType('btnmatrix') || node.isType('mtrx_btn')) {
            return obj !== 'btn';
        }
        if (node.isType('msgbox') || node.isType('msgbox_btn')) {
            return obj !== 'btn';
        }
    }
    return obj === 'tab'
}

function disableScreeshot(node) {
    if (node !== undefined) {
        return !node.isType('page');
    }
    return true;
}

function disableDelete(node) {
    if (node !== undefined) {
        return node.no_delete
    }
    return true;
}

function disableCopy(node) {
    if (node !== undefined) {
        return !node.can_copy
    }
    return true;
}

export { disableComponent, disableCopy, disableDelete, disableScreeshot }
